import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import F84Game from "../Game";
import ARIA from "../utils/ARIA";
import BaseURL from "../utils/BaseURL";
import Fonts from "../utils/Fonts";
import InitialLoadUtils from "../utils/InitialLoadUtils";
import WebPlayerData from "../WebPlayerData";
import LoaderScene from "./LoaderScene";

export default class BootScene extends LoaderScene {
	loaded: boolean;
	partnerLoaded: boolean;

	preload(): void {
		console.log("preload");
		console.log(F84Game.Instance.locale);

		this.load.setBaseURL(BaseURL.getBaseURL());

		const playerData = new WebPlayerData("flurrys-search-and-rescue");
		playerData.load();

		this.load.script("file-saver", "./libs/FileSaver.js");

		// Loading Conatiner Images
		this.loadImages("./assets/images/temp/", {
			whiteCircle: "white-circle",
			whiteSquare: "white-square",
		});

		this.loadImages("./assets/images/ui/splash-loading/ag-lumi-", {
			playButton: "btn-play",
			resetButton: "btn-reset",
			splashLogo: "hog-logo",
			splashBG: "hog-splash-bg",
			splashCharacters: "hog-splash-characters",
			splashBushes: "hog-splash-fg-bushes",
			loadingBarFill: "loading-fill",
			loadingBarBG: "loading-meter",
			loadingLogo: "loading-logo",
		});

		this.loadJson("strings", "./locale/strings.json", false);

		this.loadJson("gameConfig", "./assets/json/game-config.json", false);

		this.loadImage("rotateDevice", "./assets/images/system/orientation.png");

		for (let i = 1; i <= 4; i++) {
			this.loadJson(`level0${i}-day`, `./assets/json/levels/level-0${i}-day.json`, false);
			this.loadJson(`level0${i}-night`, `./assets/json/levels/level-0${i}-night.json`, false);
		}
		this.loadJson("flurry-tileset", "./assets/json/flurry-tileset.json", false);

		this.load.webfont(Fonts.MontserratBold, Fonts.MontserratBold);
		this.load.webfont(Fonts.MontserratExtraBold, Fonts.MontserratExtraBold);
	}

	create(): void {
		console.log("BootScene.create()");
		super.create();
		GameConfig.loadConfigFile(this.cache, "gameConfig");
		console.log(Strings.get("GameTitle"));

		const destinationScene = GameConfig.get("startScene");
		console.log("destinationScene: " + destinationScene);

		ARIA.init();
		InitialLoadUtils.hideInitialLoader();

		this.game.scene.start("PreloaderScene", {
			destinationScene: destinationScene,
			initalLoad: true,
		});
	}
}
